import { useCallback } from "react";
import { notification } from "antd";

const typeStyles = {
  success: {
    borderLeft: "4px solid #256d3e",
  },
  error: {
    borderLeft: "4px solid #ff4d4f",
  },
  info: {
    borderLeft: "4px solid #1677ff",
  },
  warning: {
    borderLeft: "4px solid #faad14",
  },
};

export const useAppNotification = () => {
  const [api, contextHolder] = notification.useNotification();

  const notify = useCallback(
    ({
      type = "info",
      title = "",
      description,
      placement = "bottomRight",
      duration = 2,
      ...rest
    }) => {
      const typeStyle = typeStyles[type] || {};

      api[type]({
        title,
        description,
        placement,
        duration,
        style: {
          ...typeStyle,
        },
        ...rest,
      });
    },
    [api]
  );

  const notifySuccess = useCallback((options) => notify({ ...options, type: "success" }), [notify]);
  const notifyError = useCallback((options) => notify({ ...options, type: "error" }), [notify]);
  const notifyInfo = useCallback((options) => notify({ ...options, type: "info" }), [notify]);
  const notifyWarning = useCallback((options) => notify({ ...options, type: "warning" }), [notify]);

  return {
    contextHolder,
    notify,
    notifySuccess,
    notifyError,
    notifyInfo,
    notifyWarning,
  };
};
